import { useContext } from 'react';

import FailedOrdersContext from './FailedOrdersContext';

const useFailedOrders = () => {
  return useContext(FailedOrdersContext);
};

export default useFailedOrders;
